<template>
  <div :class="classes(n(), n(`--${direction}`))">
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'virtual-vue';
import { stepProps } from './props';
import { emits } from './emits';
import { createNamespace } from '../utils/components';
import { useStep } from './hooks';

const { name, n, classes } = createNamespace('step');

export default defineComponent({
  name,
  props: stepProps,
  emits,
  setup(props) {
    const { direction } = useStep(props);

    return {
      n,
      classes,
      direction,
    };
  },
});
</script>
